import { useEffect,useState } from 'react'
import { useLocation,useParams } from 'react-router-dom'

import { AxiosError } from 'axios'

import { getAccountById } from 'api'

export interface AccountDetailsPageParams {
  id: string
}

export interface LocationState {
  navigatedFromUrl: any
  accountData?: {
    name?: string
  }
  navigatedFrom?: string
  accountEngagementScore?: number
}

export const useAccountCompanyTitle = () => {
  const { id: accountId } = useParams<AccountDetailsPageParams>()
  const location = useLocation<LocationState>()
  const [error, setError] = useState<AxiosError | null>(null)
  const [companyName, setCompanyName] = useState<string | undefined>(
    location.state?.accountData?.name
  )

  const locationName = location.state?.accountData?.name

  useEffect(() => {
    const callback = async () => {
      try {
        const { data } = await getAccountById(accountId)
        setCompanyName(data?.name ?? locationName)
      } catch (error) {
        setError(error as AxiosError)
      }
    }
    callback()
  }, [accountId, locationName])
  return { companyName, error }
}
